import React, {
  useState
}                   from 'react'
import ClientAxios  from '../config/clientAxios'
import Swal         from 'sweetalert2'
import Header       from './Header'
import { useMain }  from './Hooks/useMain'

const BuroComponente = () => {

  const [Nip, setNip] = useState({
    secondnip: ""
  })
  const buro_ntransaccion = sessionStorage.getItem('buro_ntransaccion')
  
  
  sessionStorage.getItem('jsonDocData')

  // const { State, DataDocumentos }         = useMain()
  const { 
    numerosocio
    , apellidopaterno
    , apellidomaterno
    , nombre
    , domicilio
    , sucursalid
    , telefono
    , email
    , ciudad
    , estado
    , codigopostal
    , finalidadprestamo
    , aniosexperiencia
    , actividadeconomica
    , monto
    , plazopago
    , sueldoingreso
    , otrosingreso
    , curp
    , colonia              
    , gs_vivienda          
    , gs_entretenimientodig
    , gs_alimentacion      
    , gs_movil             
    , gs_aseo              
    , gs_transporte        
    , gs_vehiculo          
    , gs_salud             
    , gs_agua              
    , gs_entretenimiento   
    , gs_predial           
    , gs_vestimenta        
    , gs_luz               
    , gs_impuestospension  
    , gs_gas               
    , gs_otrosgastos   
    , comprobantedomicilio 
    , identificacionfrente 
    , identificacionreverso
    , comprobanteingresos      
  } = JSON.parse(sessionStorage.getItem('jsonData'))

  
  var jsondata = {
    numerosocio
    , apellidopaterno
    , apellidomaterno
    , nombre
    , domicilio
    , sucursalid
    , telefono
    , email
    , ciudad
    , estado
    , codigopostal
    , finalidadprestamo
    , aniosexperiencia
    , actividadeconomica
    , monto
    , plazopago
    , sueldoingreso
    , otrosingreso
    , curp
    , colonia              
    , gs_vivienda          
    , gs_entretenimientodig
    , gs_alimentacion      
    , gs_movil             
    , gs_aseo              
    , gs_transporte        
    , gs_vehiculo          
    , gs_salud             
    , gs_agua              
    , gs_entretenimiento   
    , gs_predial           
    , gs_vestimenta        
    , gs_luz               
    , gs_impuestospension  
    , gs_gas               
    , gs_otrosgastos     
    , comprobantedomicilio 
    , identificacionfrente 
    , identificacionreverso
    , comprobanteingresos  
  }

  const DataDocumentos = JSON.parse(sessionStorage.getItem('jsonDocData'))
  console.log(DataDocumentos);
  
  jsondata.CDomicilio_DocName = DataDocumentos.CDomicilio_DocName
  jsondata.CDomicilio_DocType = DataDocumentos.CDomicilio_DocType
  jsondata.IFrente_DocName    = DataDocumentos.IFrente_DocName
  jsondata.IFrente_DocType    = DataDocumentos.IFrente_DocType
  jsondata.IReverso_DocName   = DataDocumentos.IReverso_DocName
  jsondata.IReverso_DocType   = DataDocumentos.IReverso_DocType
  jsondata.CIngresos_DocName  = DataDocumentos.CIngresos_DocName.length > 0 ? DataDocumentos.CIngresos_DocName : DataDocumentos.CDomicilio_DocName 
  jsondata.CIngresos_DocType  = DataDocumentos.CIngresos_DocType.length > 0 ? DataDocumentos.CIngresos_DocType : DataDocumentos.CDomicilio_DocType

  //* 


  const {
    secondnip
  } = Nip

  const handleChange = e => {
    e.preventDefault()  
    setNip({
      ...Nip,
      [e.target.name] : e.target.value
    })
  }

  const onSubtmit = async e => {
    e.preventDefault()
    const response = await ClientAxios.put('/api/nip', {secondnip, buro_ntransaccion, jsondata}, {
      headers:{"x-auth-token": sessionStorage.getItem('token')}
    })

    if (response.data.error === false && response.data.segunda === true) {
      Swal.fire({
        icon:"success",
        title: response.data.title,
        text: response.data.msg,
        confirmButtonText: "ok"
      })
      setTimeout(() => {
        sessionStorage.removeItem('primera')
        sessionStorage.removeItem('token')
        sessionStorage.removeItem('registro')
        window.location.href = 'https://cpapaseo.com.mx/'
      }, 3500);
    }

    if (response.data.error === true) {
      Swal.fire({
        icon:"error",
        title: response.data.msg,
        confirmButtonText: "ok"
      })
    }
    
  }

  return (
    <>
      <Header/>
      <div className="container ps-4 pe-4">
        <div className="row mt-5">
          <div className="col-12">
            <div className="p" style={{textAlign: 'justify', fontSize: 20}}>
              Autorizo expresamente a <strong>Caja Popular Apaseo el Alto S.C. de A.P. de R.L. de C.V.</strong>, para que lleve a cabo
              Investigaciones, sobre mi comportamiento Crediticio en SIC que estime
              conveniente. Conozco la naturaleza y alcance de la información que se
              solicitará, del uso que se le dará y que se podrá realizar consultas
              periódicas de mi historial crediticio, consiento que esta autorización
              tenga vigencia de 3 años contados a partir de hoy, y en su caso
              mientras mantengamos relación jurídica.

            </div>
            <form onSubmit={onSubtmit}>
              <div className="row d-flex justify-content-center mt-5">
              <label htmlFor="secondConfirmation" className="text-center">Ingresa tu nip</label>
                <div className="col-6 mt-2">
                  
                  <input 
                    id="secondConfirmation"
                    type="password"
                    maxLength={4}
                    name="secondnip"
                    onChange={handleChange}
                    className="form-control text-center "
                    style={{border: "1px solid black"}}
                  />
                  
                </div>
                
              </div>
              <div className="row d-flex justify-content-center">
                <div className="col-6 text-center mt-4">
                  <button className="btn btn-success" >Autorizar</button>
                </div>
              </div>
            </form>
          </div>
        </div>
        
      </div>
    </>
  )
}

export default BuroComponente
